import React from "react";
import axios from "axios";

import data from "./data.json";

const objectToArray = (obj) => {
  const keys = Object.keys(obj);
  const res = [];
  for (let i = 0; i < keys.length; i++) {
    res.push([keys[i], obj[keys[i]]]);
  }
  return res;
};

function currencyFormat(num) {
  return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

const queryBTC =
  "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd";
const queryDESO =
  "https://api.coingecko.com/api/v3/simple/price?ids=bitclout&vs_currencies=usd";

class Table extends React.Component {
  constructor() {
    super();

    this.state = {
      countryList: objectToArray(data),
      btc: 0,
      deso: 0,
    };
  }

  componentDidMount() {
    const updateB = async (queryURL) => {
      await axios
        .get(queryURL)
        .then((response) => response.data)
        //   response.json())
        .then((data) =>
          this.setState(
            () => {
              // console.log(data);
              const wen = objectToArray(data);
              const price = wen[0][1].usd;
              if (queryURL === queryBTC) {
                return { btc: price.toString() };
              } else {
                return { deso: price.toString() };
              }
            },
            () => {
              console.log(this.state);
            }
          )
        );
    };
    setInterval(updateB(queryBTC), 60000);
    setInterval(updateB(queryDESO), 60000);

    console.log(this.state.countryList);
  }

  render() {
    return (
      <table className="Table-Container">
        <thead>
          <tr>
            {/* <th>#</th> */}
            <th>Country</th>
            <th>$ min. year</th>
            {/* <th>₿ Min. Yr</th> */}
            <th className="mobHide">Ð year</th>
            <th className="mobHide">$ min. month</th>
            {/* <th>₿ Min. Mth</th> */}
            <th className="mobHide">Ð month</th>
            <th>$ min. day</th>
            {/* <th>₿ Min. Day</th> */}
            <th>Ð day</th>
            <th>daily 💎</th>
            {/* <th>supply</th> */}
          </tr>
          {this.state.countryList.map((country) => {
            console.log(country[1]);
            return (
              <tr key={country[0]}>
                {/* <td>#</td> */}
                <td className="symbol">{country[0]}</td>
                <td className="symbol">
                  {currencyFormat(parseInt(country[1]))}
                </td>
                {/* <td className="symbol">
                  {"₿ " + (parseInt(country[1]) / this.state.btc).toFixed(9)}
                </td> */}
                {/* <td className="symbol ">
                  {"Ð " + (parseInt(country[1]) / this.state.deso).toFixed(2)}
                </td> */}
                {/* monthly */}
                <td className="symbol mobHide">
                  {currencyFormat(parseInt(country[1] / 12))}
                </td>
                {/* <td className="symbol">
                  {"₿ " +
                    (parseInt(country[1] / 12) / this.state.btc).toFixed(9)}
                </td> */}
                <td className="symbol mobHide">
                  {"Ð " +
                    (parseInt(country[1] / 12) / this.state.deso).toFixed(2)}
                </td>
                {/* daily */}
                <td className="symbol">
                  {currencyFormat(parseInt(country[1] / 12 / 30))}
                </td>
                {/* <td className="symbol">
                  {"₿ " +
                    (parseInt(country[1] / 12 / 30) / this.state.btc).toFixed(
                      9
                    )}
                </td> */}
                <td className="symbol">
                  {"Ð " +
                    (parseInt(country[1] / 12 / 30) / this.state.deso).toFixed(
                      4
                    )}
                </td>
                <td className="symbol">
                  {"💎 " +
                    parseInt(
                      country[1] / 12 / 30 / this.state.deso / 0.0005
                    ).toFixed(0)}
                </td>
                {/* <td>{this.state.list.id}</td> */}
              </tr>
            );
          })}
        </thead>
      </table>
    );
  }
}

export default Table;
